module.exports = __webpack_public_path__ + "static/media/game-division_icon.8448058c.svg";